(async () => {
    const { Core } = await importModule('Core');

    const CN_LOADING = '!loading';
    const ATTR_VARIANT_ID = 'variant-id';
    const ATTR_BELONGS_FORM = 'form-child';
    
    customElements.define('product-to-cart', class extends Core {
        elements = {
            button: '[data-to-cart]'
        }
        
        subscriptions = {
            'cart:update':  '_cartUpdateHandler',
            'cart:error':  '_cartUpdateHandler'
        }

        render() {
            this.subscribe('cart:update', { global: true });
            this.subscribe('cart:error', { global: true });
            this._handleClick()
        }

        _handleClick() {
            this.addEventListener('click', this._onClick.bind(this))
        }

        _onClick() {
            this.loading = true;
            !this.belongsToForm && this.addToCart(this.cartItem);
        }
 
        async addToCart(items) {
            if (this.pending) return;
            this.pending = true;
            this.loading = true;
            try {
                const list = window.RPQuoteList;
                if (!list) throw new Error('Quote list unavailable. Please reload this page.');
                const form = this.closest('form');
                const requests = items.map(item => {
                    const input = [...(form?.elements || [])].find(el => el.name?.startsWith('buy_with_') && String(el.value) === String(item.id));
                    return {...item, handle: input?.dataset.rpHandle || this.dataset.rpHandle};
                });
                const resolved = await list.resolve(requests);
                const main = resolved.find(entry => String(entry.request.id) === this.getAttribute('variant-id')) || resolved[0];
                const quoteItems = resolved.filter(entry => !main.data.direct_purchase || !entry.data.direct_purchase).map(entry => entry.item);
                const purchaseItems = resolved.filter(entry => main.data.direct_purchase && entry.data.direct_purchase).map(({request}) => {
                    const {handle, ...item} = request;
                    return item;
                });
                if (quoteItems.length) {
                    await list.add(quoteItems);
                    list.resetForm();
                }
                if (purchaseItems.length) this.publish('cart:add', {items:purchaseItems});
                else this.loading = false;
            } catch (error) {
                this.loading = false;
                window.RPQuoteList?.error(error.message);
                window.RPQuoteList?.open(this.$button);
            } finally {
                this.pending = false;
            }
        }

        _cartUpdateHandler() {
            setTimeout(() => {
                this.loading = false
            }, 1500)
        }

        get belongsToForm() {
            return this.hasAttribute(ATTR_BELONGS_FORM)
        }

        get cartItem() {
            return [{ 
                id: +this.getAttribute(ATTR_VARIANT_ID), 
                quantity: 1
            }]
        }
        
        set loading(state) {
            this.$button.classList.toggle(CN_LOADING, state);
        }

        get cartNotificationsEnabled() {
            return window.global.cartNotificationsEnabled;
        }

        set variantId(id) {
            this.setAttribute(ATTR_VARIANT_ID, id)
        }

    })
})();
